import { blue, cyan, orange, purple } from "@mui/material/colors";
import { BillItem, DocumentStatus, DocumentType, Bill } from "../pages/hospital/Billing/types";
import { stringDatePostgresToDate } from ".";
import { createT } from "../components/pdf/utils/simpleTranslate";


export function calculateTotalBill(items:BillItem[], withoutTypes:number[] = [], officialPrices = false){
    let amountSeparation = [0,0,0,0,0,0,0,0];
    for(let i = 0; i < items.length; i++){
        const currentBillItem = items[i];
        if(!withoutTypes.includes(currentBillItem.type ? parseInt(currentBillItem.type) : 0)){
            const amount = currentBillItem.amountAlter && !officialPrices ? Number(currentBillItem.amountAlter) : Number(currentBillItem.amount);
            amountSeparation[currentBillItem.type ? currentBillItem.type : 0] += Number(amount) * Number(currentBillItem.quantity);  
        }
    }
    const firstAmount = (amountSeparation[0] + amountSeparation[6] + amountSeparation[3] + amountSeparation[5] + amountSeparation[7]) - (amountSeparation[1] + amountSeparation[4]);
    let discountAmount = 0;
    if(!withoutTypes.includes(2)){
        discountAmount = (firstAmount*amountSeparation[2])/100;
    }
    const total = firstAmount - discountAmount;
    //Redondeo a dos decimales
    return  Math.round(total * 100) / 100
}

export function documentTypeToColor(type:DocumentType){
    switch(type){
        case DocumentType.BUDGET:
            return blue[500];
        case DocumentType.SUMMARY:
            return orange[500];
        case DocumentType.INVOICE:
            return purple[500];
    }
}

export function documentStatusToColor(type:DocumentStatus){
    switch(type){
        case DocumentStatus.DRAFT:
            return cyan[500];
        case DocumentStatus.CLOSED:
            return "#000";
    }
}

export function documentTypeToString(type:DocumentType){
    switch(type){
        case DocumentType.BUDGET:
            return "budget";
        case DocumentType.SUMMARY:
            return "summary";
        case DocumentType.INVOICE:
            return "invoice";
    }
}

export function getDateFromStringOrDate(date:string | Date){
    if(typeof date === "string" || date instanceof String){
        return stringDatePostgresToDate(date)
    }
    else{
        return date;
    }
}

/**
 * Generates a localized filename for a bill PDF
 * @param bill - The bill object
 * @param locale - The locale code (e.g., 'en', 'es', 'fr')
 * @returns Formatted filename string
 */
export function generateBillPDFFilename(bill: Bill, locale: string): string {
    const t = createT(locale);
    //const filenamePrefix = t('pages.hospital.billing.pdf.filename.prefix', 'bill');
    const documentTypeName = t(
        `pages.hospital.billing.pdf.filename.${documentTypeToString(bill.type)}`, 
        documentTypeToString(bill.type)
    );
    const dateStr = new Date().toISOString().split('T')[0];
    return `${documentTypeName}_${bill.documentNumber}_${dateStr}`;
}

/**
 * Calculates the total tax from bill items
 * @param items - Array of bill items with optional taxAmount
 * @returns Total tax rounded to 2 decimal places
 */
export function calculateTotalTax(items: BillItem[]): number {
    const total = items.reduce((sum, item) => sum + (Number(item.taxAmount) || 0), 0);
    return Math.round(total * 100) / 100;
}

/**
 * Calculates the total with tax (gross - discount + tax)
 * @param items - Array of bill items
 * @param totalGross - Gross total of the bill
 * @param totalDiscount - Total discount amount
 * @returns Net total (with tax) rounded to 2 decimal places
 */
export function calculateTotalWithTax(items: BillItem[], totalGross: number, totalDiscount: number): number {
    const totalTax = calculateTotalTax(items);
    return Math.round((totalGross - totalDiscount + totalTax) * 100) / 100;
}

export interface TaxBreakdownGroup {
    taxRateId: number;
    taxBase: number;
    taxAmount: number;
}

/**
 * Groups tax amounts by taxRateId for breakdown display
 * @param items - Array of bill items with taxRateId and taxAmount
 * @returns Array of tax breakdown groups, each with taxRateId, taxBase, and taxAmount
 */
export function groupTaxBreakdown(items: BillItem[]): TaxBreakdownGroup[] {
    const map = new Map<number, TaxBreakdownGroup>();
    for (const item of items) {
        if (!item.taxRateId || !item.taxAmount) continue;
        const existing = map.get(item.taxRateId);
        const itemBase = Number(item.amount) * Number(item.quantity);
        if (existing) {
            existing.taxBase += itemBase;
            existing.taxAmount += Number(item.taxAmount);
        } else {
            map.set(item.taxRateId, {
                taxRateId: item.taxRateId,
                taxBase: itemBase,
                taxAmount: Number(item.taxAmount),
            });
        }
    }
    return Array.from(map.values()).map(entry => ({
        ...entry,
        taxBase: Math.round(entry.taxBase * 100) / 100,
        taxAmount: Math.round(entry.taxAmount * 100) / 100,
    }));
}
